module.exports = __webpack_public_path__ + "img/IMG.fecc783a.png";